import { render, staticRenderFns } from "./EventActivityStats.vue?vue&type=template&id=6fb6a558&"
import script from "./EventActivityStats.vue?vue&type=script&lang=ts&"
export * from "./EventActivityStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports